import { Button, Input, message, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  PlusOutlined,
  UserAddOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import ActionTable from '../../components/table/ActionTable';
import {
  addAdminRequest,
  deleteAdminRequest,
  getAdmins,
} from '../../store/actions/admin';
import styles from './index.module.css';
import { isEmail } from '../../utils/functions';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Admin = () => {
  const { admins, loading } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useTranslation();

  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchInput, setSearchInput] = useState('');

  const [inputNewEmail, setInputNewEmail] = useState('');

  const deleteAction = (id) => {
    const callbackDelete = (status) => {
      if (status === 200) {
        message.success(t('admin.message.success.delete'));
      } else {
        message.error(t('admin.message.error.delete'));
      }

      return history.push('/admin/admins');
    };
    dispatch(deleteAdminRequest({ id, callback: callbackDelete }));
  };

  const columns = [
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '10%',
      render: (text, record) => (
        <ActionTable record={record} noEdit deleteAction={deleteAction} />
      ),
    },
  ];

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const handleSubmit = () => {
    if (!isEmail(inputNewEmail.trim())) {
      message.error(t('admin.message.error.email_valid'));
      return;
    }

    if (
      admins.filter((admin) => admin.email === inputNewEmail.trim()).length > 0
    ) {
      message.error(t('admin.message.error.email_exists'));
      return;
    }

    dispatch(
      addAdminRequest({
        body: {
          email: inputNewEmail,
        },
        callback: (response) => {
          if (response && response.ok) {
            message.success(t('admin.message.success.add'));
          } else {
            message.error(t('admin.message.error.add'));
          }
        },
      })
    );

    setInputNewEmail('');
  };

  useEffect(() => {
    if (!admins) {
      dispatch(getAdmins());
    } else {
      setDataSource(admins.map((admin) => ({ ...admin, key: admin.id })));
      setIsLoading(loading);
    }
  }, [admins, dispatch, loading]);

  useEffect(() => {
    if (searchInput) {
      setDataSource(
        admins
          .filter((admin) =>
            admin.email.toLowerCase().includes(searchInput.toLowerCase())
          )
          .map((admin) => ({ ...admin, key: admin.id }))
      );
    } else if (admins) {
      setDataSource(admins.map((admin) => ({ ...admin, key: admin.id })));
    }
  }, [admins, searchInput]);
  return (
    <div className={styles['admin-content']}>
      <div className={styles.table__header}>
        <h3 className={styles.table__title}>{t('admin.title')}</h3>
        <div className={styles.table__search}>
          <Input
            placeholder='Rechercher'
            onChange={(e) => {
              handleSearch(e.target.value.trim());
            }}
            value={searchInput}
            prefix={<SearchOutlined />}
            allowClear
          />
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        pagination={{
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} sur ${total} items`,
          total: dataSource.length,
          pageSize: 6,
        }}
        footer={() => (
          <div className={styles.table__form__group}>
            <Input
              type='email'
              value={inputNewEmail}
              placeholder='Entrer une adresse email'
              onChange={(e) => setInputNewEmail(e.target.value.toLowerCase())}
              prefix={<UserAddOutlined />}
            />
            <Button
              type='primary'
              className={styles.button}
              icon={<PlusOutlined />}
              onClick={handleSubmit}
            >
              {t('admin.button.add')}
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default Admin;
